import { isIOS } from 'react-device-detect'

declare global {
  // based on npm package `user-agent-data-types`, waiting till official one!
  interface Navigator extends NavigatorUA {}
  interface WorkerNavigator extends NavigatorUA {}

  // https://wicg.github.io/ua-client-hints/#navigatorua
  interface NavigatorUA {
    readonly userAgentData?: NavigatorUAData
  }

  // https://wicg.github.io/ua-client-hints/#dictdef-navigatoruabrandversion
  interface NavigatorUABrandVersion {
    readonly brand: string
    readonly version: string
  }

  // https://wicg.github.io/ua-client-hints/#dictdef-uadatavalues
  interface UADataValues {
    readonly brands?: NavigatorUABrandVersion[]
    readonly mobile?: boolean
    readonly platform?: string
    readonly architecture?: string
    readonly bitness?: string
    readonly model?: string
    readonly platformVersion?: string
    /** @deprecated in favour of fullVersionList */
    readonly uaFullVersion?: string
    readonly fullVersionList?: NavigatorUABrandVersion[]
    readonly wow64?: boolean
  }

  // https://wicg.github.io/ua-client-hints/#dictdef-ualowentropyjson
  interface UALowEntropyJSON {
    readonly brands: NavigatorUABrandVersion[]
    readonly mobile: boolean
    readonly platform: string
  }

  // https://wicg.github.io/ua-client-hints/#navigatoruadata
  interface NavigatorUAData extends UALowEntropyJSON {
    getHighEntropyValues(hints: string[]): Promise<UADataValues>
    toJSON(): UALowEntropyJSON
  }
}

// TODO: Consider moving this code to a separate package. This code depends on Browser API and should not be used in Node.js environment.
// Currently, the entire @dhl/utils package cannot be used in Node.js environment.

const getUserAgent = (method: keyof UADataValues): string => {
  if (navigator.userAgentData) {
    switch (method) {
      case 'brands':
        return navigator.userAgentData[method].map((elm) => `${elm.brand.toLocaleLowerCase()} ${elm.version}`).join(' ')
      case 'mobile':
        return navigator.userAgentData[method] ? 'isMobile' : 'isDesktop'
      case 'platform':
        return navigator.userAgentData[method]?.toLocaleLowerCase() || ''
      default:
        return 'not implemented'
    }
  } else {
    return navigator.userAgent.toLocaleLowerCase()
  }
}

const isAndroid = /android/.test(getUserAgent('platform'))
const isChrome = /chrome/.test(getUserAgent('brands'))
const isMobile = [isAndroid, isIOS].includes(true)
const isDesktop = !isMobile

type Device = {
  isAndroid: boolean
  isIOS: boolean
  isChrome: boolean
  isMobile: boolean
  isDesktop: boolean
}

export const device: Device = {
  isAndroid,
  isIOS,
  isChrome,
  isMobile,
  isDesktop,
}
